export default __webpack_public_path__ + "static/media/footer.71bc49e6.png";